export default function IsInputInError(value) {
    if (value) {
        return "has-error";
    }
    return "";
}
